export const convertPlnToUsd = (plnAmount) => {
  const exchangeRate = 4; // 4 PLN = 1 USD

  // Ensure plnAmount is a valid number; default to 0 if not
  const validPlnAmount = isNaN(Number(plnAmount)) ? 0 : Number(plnAmount);

  const usdAmount = (validPlnAmount / exchangeRate).toFixed(2);
  return usdAmount;
};
